import api from './client';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: 'admin' | 'manager' | 'staff' | 'user' | 'viewer';
  isActive: boolean;
  lastLoginAt?: string | null;
  authProvider?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: User['role'];
  isActive: boolean;
}

export interface UpdateUserDto {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  role?: User['role'];
  isActive?: boolean;
}

export interface UsersResponse {
  users: User[];
  total: number;
  page: number;
  limit: number;
}

export const usersApi = {
  async getMe(): Promise<User> {
    const response = await api.get<User>('/users/me');
    return response.data;
  },

  async updateMe(data: {
    firstName?: string;
    lastName?: string;
    password?: string;
    currentPassword?: string;
  }): Promise<User> {
    const response = await api.patch<User>('/users/me', data);
    return response.data;
  },

  // Get all users (admin)
  async getAll(): Promise<User[]> {
    const response = await api.get<User[]>('/users');
    return response.data;
  },

  // Get user by ID
  async getById(id: string): Promise<User> {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  },

  // Create new user
  async create(data: CreateUserDto): Promise<User> {
    const response = await api.post<User>('/users', data);
    return response.data;
  },

  // Update user
  async update(id: string, data: UpdateUserDto): Promise<User> {
    const response = await api.patch<User>(`/users/${id}`, data);
    return response.data;
  },

  // Delete user
  async delete(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },

  // Toggle user active status
  async toggleActive(id: string): Promise<User> {
    const response = await api.patch<User>(`/users/${id}/toggle-active`);
    return response.data;
  },

  // Get user by email
  async getByEmail(email: string): Promise<User> {
    const response = await api.get<User>(`/users/email/${email}`);
    return response.data;
  }
};

export default usersApi; 